import { useMutation } from "@tanstack/react-query";
import { Api, type BlogArticleInput } from "@/api";
import { blogKeys } from "./keys";

type UpdateBlogArticleInput = BlogArticleInput & { id: string };

export const useUpdateBlogArticle = () => {
	const mutation = useMutation({
		mutationFn: ({ id, ...data }: UpdateBlogArticleInput) => Api.Blog.putApiBlogById({ id }, data),
		mutationKey: blogKeys.update,
	});
	return { execute: mutation.mutateAsync, isPending: mutation.isPending };
};
